import { ChangeDetectionStrategy, Component, HostBinding, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mcrai-ul',
  template: `<ng-content></ng-content>
`,
  styles: [`.mcrai-ul{display:flex;flex-direction:column;margin:3px 0}`],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: false
})
export class UnorderedListComponent implements OnInit {
  @HostBinding('class.mcrai-ul') cssClass = true;

  constructor() { }

  ngOnInit() { }

}
